import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Wordmark } from '../components/site/Header';
import { fetchAdminSession, loginAdmin } from '../lib/auth';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    fetchAdminSession().then((session) => {
      if (mounted && session) navigate('/admin/dashboard');
    });
    return () => {
      mounted = false;
    };
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await loginAdmin(email.trim().toLowerCase(), password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center">
          <Wordmark />
          <p className="font-mono-tech text-[11px] tracking-[0.24em] uppercase text-muted-foreground mt-3">Lead Management</p>
        </div>
        <form onSubmit={handleLogin} className="mt-8 bg-card border border-border rounded-xl p-6 sm:p-8 space-y-4">
          <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center">
            <Lock className="w-4 h-4 text-muted-foreground" />
          </div>
          <div>
            <label htmlFor="admin-email" className="text-sm font-medium">Email</label>
            <Input id="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin email" className="h-11 mt-1.5" data-testid="admin-email-input" required />
          </div>
          <div>
            <label htmlFor="admin-password" className="text-sm font-medium">Password</label>
            <Input id="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password" className="h-11 mt-1.5" data-testid="admin-password-input" required />
          </div>
          {error && <p className="text-sm text-destructive" role="alert" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" className="w-full h-11" disabled={loading} data-testid="admin-login-button">
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}
